// extracted by mini-css-extract-plugin
module.exports = {"root":"Icon_system_root__dObTT"};